var map = {
	"./actions/ordini": [
		276
	],
	"./actions/ordini.js": [
		276
	],
	"./apis/ordini": [
		451
	],
	"./apis/ordini.js": [
		451
	],
	"./components/OrdiniEdit": [
		1256,
		335
	],
	"./components/OrdiniEdit.js": [
		1256,
		335
	],
	"./components/OrdiniListFilter": [
		1446,
		4,
		46
	],
	"./components/OrdiniListFilter.js": [
		1446,
		4,
		46
	],
	"./components/OrdiniListFooter": [
		1257,
		336
	],
	"./components/OrdiniListFooter.js": [
		1257,
		336
	],
	"./components/OrdiniListTable": [
		1258,
		329
	],
	"./components/OrdiniListTable.js": [
		1258,
		329
	],
	"./components/SummaryFooter": [
		1259,
		330
	],
	"./components/SummaryFooter.js": [
		1259,
		330
	],
	"./components/SummaryTable": [
		1260,
		331
	],
	"./components/SummaryTable.js": [
		1260,
		331
	],
	"./containers/OrdiniListLayout": [
		1531,
		4,
		14,
		46,
		332
	],
	"./containers/OrdiniListLayout.js": [
		1531,
		4,
		14,
		46,
		332
	],
	"./containers/OrdiniLoader": [
		1532,
		333
	],
	"./containers/OrdiniLoader.js": [
		1532,
		333
	],
	"./helpers": [
		1053,
		334
	],
	"./helpers.js": [
		1053,
		334
	],
	"./reducers/ordini": [
		167
	],
	"./reducers/ordini.js": [
		167
	],
	"./routes/ordini": [
		536
	],
	"./routes/ordini.js": [
		536
	],
	"./sagas/ordini": [
		622
	],
	"./sagas/ordini.js": [
		622
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2128;
module.exports = webpackAsyncContext;